// src/pages/Competitions/components/CompetitionsPagination.jsx
import React from "react";

export default function CompetitionsPagination({
  page,
  setPage,
  pageCount,
  pageSize,
  setPageSize,
  total,
}) {
  return (
    <div className="flex flex-col gap-3 rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:flex-row sm:items-center sm:justify-between">
      <div className="text-sm font-medium text-slate-600 dark:text-slate-300">
        {total} résultat{total > 1 ? "s" : ""} • Page{" "}
        <strong>{page}</strong> / <strong>{pageCount}</strong>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <PaginationButton onClick={() => setPage(1)} disabled={page <= 1}>
          «
        </PaginationButton>

        <PaginationButton
          onClick={() => setPage((previous) => Math.max(1, previous - 1))}
          disabled={page <= 1}
        >
          ‹
        </PaginationButton>

        <select
          value={String(pageSize)}
          onChange={(event) => {
            setPageSize(Number(event.target.value));
            setPage(1);
          }}
          className="rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 outline-none dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100"
        >
          <option value="10">10 / page</option>
          <option value="25">25 / page</option>
          <option value="50">50 / page</option>
          <option value="100">100 / page</option>
        </select>

        <PaginationButton
          onClick={() =>
            setPage((previous) => Math.min(pageCount, previous + 1))
          }
          disabled={page >= pageCount}
        >
          ›
        </PaginationButton>

        <PaginationButton
          onClick={() => setPage(pageCount)}
          disabled={page >= pageCount}
        >
          »
        </PaginationButton>
      </div>
    </div>
  );
}

function PaginationButton({ children, onClick, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="inline-flex h-10 min-w-10 items-center justify-center rounded-2xl border border-slate-200 bg-white px-3 text-sm font-bold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:hover:bg-slate-800"
    >
      {children}
    </button>
  );
}